module.exports = __webpack_public_path__ + "static/media/ForkLiftingIcon.251e1c2f.svg";